import React from 'react';
import PropTypes from 'prop-types';
import { Form, FormGroup } from 'react-bootstrap';
import { Button } from '@storable/canaveral-components';
import classes from './UnitFilter.scss';
import Icon from '../../../../modules/react/components/stateless/Icon';

const propTypes = {
  onFilterChange: PropTypes.func.isRequired,
};

const UnitFilter = ({ onFilterChange, filterText }) => {
  const resetSearch = () => {
    onFilterChange('');
  };

  const handleTextInput = ({ target: { value } }) => {
    onFilterChange(value);
  };

  return (
    <div className={classes.filterSearch}>
      <div className="form-horizontal">
        <FormGroup
          controlId="filterUnits"
          className={classes.formGroup}
        >
          <div className={classes.filterUnits}>
            <Form.Control
              type="text"
              placeholder="search..."
              className={classes.filterSearchBar}
              onChange={handleTextInput}
              value={filterText}
              data-testid="filterInput"
            />
            <div className={classes.formControlFeedback}>
              {filterText.length
                ? (
                  <Button
                    context="bare"
                    label="close"
                    className={classes.exitIcon}
                    onClick={resetSearch}
                    data-testid="resetButton"
                  >
                    <Icon
                      id="exit"
                      label="exitIcon"
                    />
                  </Button>
                )
                : <span className="fa fa-search" aria-hidden="true" />
              }
            </div>
          </div>
        </FormGroup>
      </div>
    </div>
  );
};

UnitFilter.propTypes = propTypes;

export default UnitFilter;
